"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _theme = _interopRequireDefault(require("./Themes/theme"));

var sizes = {
  desktopXl: _theme["default"].responsiveDesktopXl,
  desktop: _theme["default"].responsiveDesktop,
  topnavMobile: _theme["default"].responsiveTopnavMobile,
  xlarge: _theme["default"].responsiveLargeXl,
  portfolioDesktop: _theme["default"].responsivePortfolioDesktop,
  large: _theme["default"].responsiveLarge,
  medium: _theme["default"].responsiveMedium,
  xSmall: _theme["default"].responsiveSmallXl,
  small: _theme["default"].responsiveSmall,
  // portfolio size
  portfolioMedium: _theme["default"].responsivePortfolioMedium,
  portfolioLarge: _theme["default"].responsivePortfolioLarge
}; //  0 - 767px screen width

var mobileOnly = function mobileOnly() {
  return (0, _styledComponents.css)(["@media (max-width:", "){", "}"], function (props) {
    return props.theme.responsiveMedium - 1;
  }, _styledComponents.css.apply(void 0, arguments));
};

var minWidth = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(["@media (min-width:", "px){", "}"], sizes[label], _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
var maxWidth = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(["@media (max-width:", "px){", "}"], sizes[label], _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
var retina = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(["@media only screen and (-webkit-min-device-pixel-ratio:1.3),only screen and (-o-min-device-pixel-ratio:13/10),only screen and (min-resolution:120dpi){", "}"], _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
var media = {
  mobileOnly: mobileOnly,
  minWidth: minWidth,
  maxWidth: maxWidth,
  retina: retina
};
var _default = media;
exports["default"] = _default;